
  export default {
    name: 'SelectInput',
    props: {
      availableFields: Array,
      name: String,
      label: String,
      value: String,
      holder: String,
      error: String
    },

    data () {
      return {
        selectedVal: String
      }
    }
  }
